import overview from "../../assets/img/maintenance-stairs.PNG";

const MaintenanceStairs = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="fisherman-content">
                <h4>Standard Maintenance Stair (2/3/4 Step)-MST2-MST4-900</h4>
                <p>
                  The maintenance stair is used for carrying out inspection and
                  maintenance work on aircraft. The aircraft maintenance stair
                  designed and engineered may be used on different aircraft type
                  whether at the apron or at aircraft maintenance hangar, in
                  order to carry out inspection and maintenance tasks. The stair
                  height must be adapted to the working height. The maximum load
                  specified for the stair (sign on the stair riser) must not be
                  exceeded. The unit must not be used for transporting persons,
                  objects or for other purposes.
                </p>
                <ul>
                  <li>
                    <strong>Aluminium construction</strong>
                  </li>
                  <li>
                    <strong>Platform height above ground: </strong>500/750/1000
                    mm
                  </li>
                  <li>
                    <strong>Platform dimensions: </strong>length 900 mm x width
                    1000mm
                  </li>
                  <li>
                    <strong>
                      Platform and steps made of anti-skid aluminium profiles
                    </strong>
                  </li>
                  <li>
                    <strong>Steps : 2/3/4 Height of steps: </strong>250 mm
                  </li>
                  <li>
                    <strong>Access width: </strong>1000 mm
                  </li>
                  <li>
                    <strong>2 wheels: </strong>Diameter 160 mm
                  </li>
                  <li>
                    <strong>Stair load: </strong>max. 1 person/step
                  </li>
                  <li>
                    <strong>Platform load: </strong>max. 300 kg (250 kg/m²) or 2
                    people
                  </li>
                  <li>
                    <strong>Design: </strong>as requested, first and upper step
                    yellow
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="overviewFigure">
                <img src={overview} alt="Overview" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MaintenanceStairs;
